import { Reveal, MaskedHeading } from "../Reveal";
import { BENEFITS } from "../../data/content";

export default function Promise() {
  return (
    <section
      className="section bg-pearl text-abyss py-24 md:py-40 relative"
      data-testid="promise-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <span className="chapter-num text-turquoise">CHAPITRE 03 — LA PROMESSE</span>
        <MaskedHeading
          tag="h2"
          className="font-display font-medium text-[clamp(2.3rem,5vw,4.4rem)] leading-[1.03] tracking-tight text-abyss mt-8 max-w-4xl"
          lines={["Sept jours pour remettre", "du vivant dans le mouvement"]}
        />

        <div className="grid lg:grid-cols-2 gap-10 lg:gap-20 mt-12">
          <Reveal className="space-y-5 text-abyss/75 text-lg leading-relaxed">
            <p>
              Pendant sept jours, tu seras invité à ralentir suffisamment pour sentir,
              mais pas à t'arrêter de vivre.
            </p>
            <p>
              À travers trois grandes soirées, des transmissions, des expériences simples
              et des temps d'intégration, tu exploreras une manière plus directe d'entrer
              en relation avec toi-même.
            </p>
            <p>Il ne s'agit pas de forcer une transformation spectaculaire.</p>
          </Reveal>
          <Reveal delay={0.1} className="space-y-5 lg:pt-2">
            <p className="font-display italic text-2xl md:text-3xl leading-snug text-abyss">
              Il s'agit de créer les conditions d'une rencontre.
            </p>
            <p className="text-abyss/75 text-lg leading-relaxed">
              Une rencontre avec ce qui t'appelle. Avec ce qui s'est peut-être tu. Avec la
              part de toi qui n'a pas besoin d'être convaincue, mais entendue.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-abyss/10 mt-20 rounded-sm overflow-hidden">
          {BENEFITS.map((b, i) => (
            <Reveal
              key={b.title}
              delay={i * 0.08}
              className="bg-pearl p-8 md:p-9 flex flex-col gap-4 group"
            >
              <span className="font-display text-5xl text-turquoise/30 group-hover:text-gold transition-colors duration-500">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="font-display text-2xl md:text-[1.7rem] text-abyss leading-tight">
                {b.title}
              </h3>
              <p className="text-abyss/70 text-[0.95rem] leading-relaxed">{b.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
